import React from 'react'

export interface ITexts {
  revtherHeader: string
  revtherDescription: string
  revtherLink: string
  poolsHeader: string
  poolsDescription: string
  poolsLink: string
  designHeader: string
  designDescription: string
  photosHeader: string
  photoDescription: string
  adventureHeader: string
  adventureDescription: string
  adventureLink: string
  commercialHeader: string
  commercialDescription: string
  commercialLink: string
  techHeader: string
  techDescription: string
  techLink: string
  aboutText: string
  techStack: string
  seoCommercial: string
  seoTech: string
  seoAdventure: string
  seoDesign: string
  seoHomepage: string
  seoContact: string

  certificationsHeader: string
  certificationsDescription: string
  seoCertifications: string

  projectsHeader: string
  projectsDescription: string
  seoProjects: string

  publicationsHeader: string
  publicationsDescription: string
  seoPublications: string

  aiMlHeader: string
  aiMlDescription: string
  seoAiMl: string

  architectureHeader: string
  architectureDescription: string
  seoArchitecture: string

  backEndHeader: string
  backEndDescription: string
  seoBackEnd: string

  cloudHeader: string
  cloudDescription: string
  seoCloud: string

  dataEngineeringHeader: string
  dataEngineeringDescription: string
  seoDataEngineering: string

  frontEndHeader: string
  frontEndDescription: string
  seoFrontEnd: string
}

export interface IValues {
  texts: ITexts
}
export type ContextProviderTypes = {
  children?: React.ReactNode
}

export const CreateContext = React.createContext<IValues | null>(null)

const TEXTS: ITexts = {
  seoCommercial:
    'Automotive photography portfolio by Kacper Michalik-software engineer and photographer. Curated frames from commercial and editorial car shoots: form, light, and detail in high-impact stills.',
  seoAdventure:
    'Adventure and travel photography by Kacper Michalik. Landscapes and expeditions from the road-personal portfolio work alongside his software engineering career.',
  seoDesign:
    'UI and web design work by Kacper Michalik: product-minded interfaces, clear hierarchy, and craft across web projects-shown as a complement to his engineering portfolio.',
  seoHomepage:
    'Kacper Michalik — software engineer & architect building AI/ML systems at Screen Studio. AWS Certified AI Practitioner. Published in SD Times, Built In, DZone.',
  seoContact:
    'Contact Kacper Michalik — software engineer and architect — for AI/ML, cloud, or product engineering roles and collaboration. AWS AI-certified.',
  seoTech:
    'Tech product photography by Kacper Michalik: hardware, desks, and gear-still-life and lifestyle shots from his portfolio (software engineer & photographer).',

  revtherHeader: 'Revther',
  revtherDescription:
    'Track crypto prices and check NFT portfolio by ETH address',
  revtherLink: 'https://app.revther.com',

  poolsHeader: 'Pools',
  poolsDescription: 'See real time data from Uniswap pools',
  poolsLink: 'https://pools-app.vercel.app/',

  designHeader: 'Design',
  designDescription:
    'Selected work from design field. Mainly UI and web design.',

  photosHeader: 'Photo&Retouch',
  photoDescription:
    'I am passionate about photography and have more than 10 years experience in this field. During this time I have mostly focused on two main fields: automotive and adventure photography.',

  adventureHeader: 'Adventure Photography',
  adventureDescription:
    'A COLLECTION OF PHOTOS FROM MY TOP VISITED DESTINATIONS',
  adventureLink: '/adventure',

  commercialHeader: 'Automotive',
  commercialDescription:
    'Selected images from my work related to automotive photography',
  commercialLink: '/automotive',

  techHeader: 'Tech',
  techDescription: 'Selected images from tech photography',
  techLink: '/tech',

  aboutText: `I'm a software engineer, architect, and product builder with 
8+ years in tech. Started in design, evolved into full-stack 
engineering, cloud, and AI/ML.

Currently building Screen Studio - #1 Product Hunt 2025, 
trusted by teams at GitHub, Vercel, and YCombinator. I own 
end-to-end delivery across the entire product: desktop app, 
APIs, infrastructure, and growth.

Now deeply focused on AI/ML engineering - building 
AI-powered products and going deep on machine learning systems.

AWS Certified. Published in SD Times, Built In, DZone, 
and HackerNoon. Online: GitHub casp3ro, X @casp3ro_.`,
  techStack:
    'TypeScript / Python / React / Next.js / Gatsby / Node.js / NestJS / PyTorch / Pandas / NumPy / Matplotlib / scikit-learn / LLMs / RAG / MLOps / AWS (incl. AI services) / PostgreSQL / GraphQL / tRPC / Redis / Ethereum / Solidity / Docker / Jest / AI / Machine Learning / macOS',

  certificationsHeader: 'Certifications',
  certificationsDescription:
    'AWS and AI credentials earned alongside shipping production software.',
  seoCertifications:
    "Kacper Michalik's AWS and AI certifications: AWS Certified Solutions Architect, AWS Certified AI Practitioner, AWS Certified Cloud Practitioner, and AI_devs2-validated cloud and applied AI/ML expertise.",

  projectsHeader: 'Projects',
  projectsDescription:
    'Products Kacper Michalik has built or co-built—Screen Studio, AI tools, and full-stack apps shipped end-to-end.',
  seoProjects:
    'Software projects by Kacper Michalik: Screen Studio (#1 Product Hunt 2025), O-1A Hub, plus open-source DSA and System Design guides.',

  publicationsHeader: 'Publications',
  publicationsDescription:
    'Technical articles by Kacper Michalik on AI, machine learning, cloud, and software engineering.',
  seoPublications:
    'Technical writing by Kacper Michalik in SD Times, Built In, DZone, and HackerNoon-covering AI/ML, MLOps, cloud architecture, and full-stack software engineering.',

  aiMlHeader: 'AI & Machine Learning',
  aiMlDescription:
    'Applied AI/ML by Kacper Michalik—LLMs, RAG, evaluation, and MLOps shipped in real products.',
  seoAiMl:
    "Kacper Michalik's AI/ML work: LLMs, RAG, prompt evaluation, and MLOps in O-1A Hub. AWS Certified AI Practitioner; DZone on prompting and metrics.",

  architectureHeader: 'Software Architecture',
  architectureDescription:
    'System design by Kacper Michalik—scalability, fault tolerance, and maintainable product systems.',
  seoArchitecture:
    'Software architecture by Kacper Michalik: system design for Screen Studio and an open-source System Design guide covering scalability and fault tolerance.',

  backEndHeader: 'Back-End Engineering',
  backEndDescription:
    'APIs, services, and data layers by Kacper Michalik—Node.js, NestJS, PostgreSQL, GraphQL, and tRPC.',
  seoBackEnd:
    'Back-end engineering by Kacper Michalik: Node.js, NestJS, PostgreSQL, GraphQL, and tRPC powering Screen Studio; writing on API design and NestJS + Docker.',

  cloudHeader: 'Cloud Architecture',
  cloudDescription:
    'AWS infrastructure by Kacper Michalik—Solutions Architect, AI Practitioner, and Cloud Practitioner certified.',
  seoCloud:
    'Cloud architecture by Kacper Michalik on AWS: Certified Solutions Architect, AI Practitioner, and Cloud Practitioner—production infrastructure, not theory.',

  dataEngineeringHeader: 'Data Engineering',
  dataEngineeringDescription:
    'Pipelines, feature engineering, and evaluation tooling by Kacper Michalik for ML-ready data.',
  seoDataEngineering:
    'Data engineering by Kacper Michalik: pipelines, feature engineering, and model evaluation with Python, Pandas, and NumPy; DZone on splits and metrics.',

  frontEndHeader: 'Front-End Engineering',
  frontEndDescription:
    'Product interfaces by Kacper Michalik—React, Next.js, and TypeScript with performance and motion in mind.',
  seoFrontEnd:
    'Front-end engineering by Kacper Michalik: React, Next.js, and TypeScript UIs for Screen Studio; published on React animation (SD Times).',
}

const CONTEXT_VALUE: IValues = { texts: TEXTS }

const ContextProvider: React.FC<ContextProviderTypes> = ({ children }) => {
  return (
    <CreateContext.Provider value={CONTEXT_VALUE}>
      {children}
    </CreateContext.Provider>
  )
}

export default ContextProvider
